module.exports = __webpack_public_path__ + "fonts/font.c802c664.woff";